/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTornado = createReactComponent("tornado", "IconTornado", [
  ["path", { d: "M21 4l-18 0", key: "svg-0" }],
  ["path", { d: "M13 16l-6 0", key: "svg-1" }],
  ["path", { d: "M11 20l4 0", key: "svg-2" }],
  ["path", { d: "M6 8l14 0", key: "svg-3" }],
  ["path", { d: "M4 12l12 0", key: "svg-4" }]
]);

export { IconTornado as default };
//# sourceMappingURL=IconTornado.js.map
